import { FeatureItem } from '../../utils';
import React from 'react';
import { Tab } from '../Tab';
import { getSpatialRecord } from '../../../../redux/risk/actions';
import { selectSpatialRecordById } from '../../../../redux/risk/selectors';
import { useGlobalization } from '@Translations/useGlobalization';

interface OtherTabProps {
	items: FeatureItem[];
	highlightAssets?: (assets: string[]) => void;
}

export const OtherTab = ({
	items,
	highlightAssets,
}: OtherTabProps): JSX.Element => {
	const { t } = useGlobalization();

	return (
		<Tab
			items={items}
			tabName={t('Spatial', {
				context: 'Property pane tab heading',
			}) ?? 'Spatial'}
			getItemDetailsSelector={selectSpatialRecordById}
			getItemDetailsAction={getSpatialRecord}
			getItemDetailsOnList
			highlightAssets={highlightAssets}
		/>
	);
};
